/**
 * One control for every pick-one-of-N choice.
 *
 * Seats, turn timer and format family are the same decision wearing three
 * different costumes if you let them — numbers in circles here, pills there.
 * They are all this.
 */
export interface SegmentedOption<T extends string | number> {
  value: T;
  label: string;
  disabled?: boolean;
}

export interface SegmentedProps<T extends string | number> {
  value: T;
  options: SegmentedOption<T>[];
  onChange: (value: T) => void;
  disabled?: boolean;
  label: string;
  /** Equal-width segments, for short labels like seat counts. */
  even?: boolean;
}

export function Segmented<T extends string | number>({
  value,
  options,
  onChange,
  disabled = false,
  label,
  even = false,
}: SegmentedProps<T>) {
  return (
    <div
      className={`segmented${even ? ' segmented--even' : ''}`}
      role="radiogroup"
      aria-label={label}
    >
      {options.map((option) => {
        const selected = option.value === value;
        return (
          <button
            key={String(option.value)}
            type="button"
            role="radio"
            aria-checked={selected}
            className={`segmented__item${selected ? ' is-on' : ''}`}
            disabled={disabled || option.disabled}
            onClick={() => onChange(option.value)}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
